import { useTranslation } from 'react-i18next';
import { Icon, S } from '../../regureStyles';

const ConfirmationModal = ({ showModal, setShowModal, loading, message, handleRemoveUser, buttonLabel, title }) => {
  const { t } = useTranslation();
  return showModal ? (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: 28, width: 520, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: S.textPrimary }}>{title ? title : t('screens.chat.removeUser')}</div>
          <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
            <Icon name='x' color={S.textMuted} size={18} />
          </button>
        </div>
        <p className='primaryText' style={{ fontSize: '1.4rem', marginBottom: '3rem' }}>
          {message}
        </p>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
          <button
            onClick={() => setShowModal(false)}
            style={{
              padding: '9px 18px',
              background: S.bgCard,
              border: `1px solid ${S.borderLight}`,
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 500,
              color: S.textSecondary,
              cursor: 'pointer',
            }}
          >
            {t('screens.chat.cancel')}
          </button>
          <button
            onClick={handleRemoveUser}
            style={{
              padding: '9px 22px',
              background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              opacity: 1,
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ConfirmationModal;
